<div class="flex h-full items-start justify-between">
  <div class="flex items-start justify-start gap-2">
    <ng-content />
    <ng-content select="[quick-actions]" />
  </div>
  <ng-content select="[dropdown-menu]" />
</div>
